import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/CyberClub/components/Archive2022';
import CyberSidebar2026 from '../CyberSidebar2026';


const SeniorCyber2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/association/Cyber/SeniorCyberAssociation/8.webp`;
    const photos = [
        {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5, 
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,                
    cols: 1,
},{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},{

    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
}





    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    ‘CIPHER QUEST
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                      Class: 9 to 12  Date: 28 October 2026   
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The Senior Cyber Association successfully conducted the inter-house event ‘Cipher Quest’ on 28 September 2026, with the aim of enhancing cybersecurity awareness, technical thinking and problem-solving skills among students. Teams from Classes 9 to 12 participated in a series of challenges based on operating systems, digital forensics, encoding, encryption and cryptography.
                                    <br></br>
Students traced clues, analysed digital evidence and cracked layered ciphers to uncover hidden messages. The challenges tested their technical accuracy, analytical thinking, speed, reasoning and teamwork, while encouraging students to apply their knowledge beyond theoretical concepts. ‘Cipher Quest’ proved to be an engaging platform for students to explore cybersecurity concepts and strengthen their problem-solving and collaborative skills. 
                                    <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h5'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
“BEHIND EVERY SECURE SYSTEM LIES A MIND THAT QUESTIONS, ANALYSES, AND CONNECTS THE CLUES—TURNING CHALLENGES INTO DISCOVERY AND KNOWLEDGE INTO DIGITAL DEFENCE.”                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <CyberSidebar2026/>
                        </Box>

                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default SeniorCyber2026;